/**
 * Converts all empty strings ("") in an object into null values.
 * Works recursively on nested objects and arrays.
 */
export function convertEmptyStringsToNull(input: any): any {
    // If the value is exactly an empty string, convert it to null
    if (input === "") {
        return null;
    }

    // If the value is an array, process each element
    if (Array.isArray(input)) {
        return input.map(item => convertEmptyStringsToNull(item));
    }

    // If the value is a plain object, process all its keys
    if (typeof input === "object" && input !== null) {
        const output: Record<string, any> = {};

        for (const key of Object.keys(input)) {
            output[key] = convertEmptyStringsToNull(input[key]);
        }

        return output;
    }

    // In all other cases (number, boolean, null, undefined): return as-is
    return input;
}